import { useContext, useEffect, useState } from 'react';
import { ListView, ListViewHeader, ListViewFooter, ListViewItemProps } from '@progress/kendo-react-listview';
import { Editor, EditorTools } from '@progress/kendo-react-editor';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { getAccountNotes } from '../services/apiService';
import { PageContext } from './PageContext';
import parse from 'html-react-parser';
import { ButtonGroup } from 'reactstrap';

interface accountNotesProps{
    onClose:()=>void
}

export function AccountNotes(props:accountNotesProps){

    const [accountNotes, setAccountNotes]=useState()
    const pageContext=useContext(PageContext);
    const [showAdd, setShowAdd]=useState(true);
    const [showEditor, setShowEditor]=useState(false);
    const getAcctNotes =()=>{
        const account = pageContext?.selectedAd.fileSize2||"";
        console.log(account);
        getAccountNotes(account).then(data=>setAccountNotes(data));
    }

    const showAddButton=()=>{
        setShowAdd(true);
        setShowEditor(false);
    }

    const hideAddButton=()=>{
        setShowAdd(false);
        setShowEditor(true);
    }


    const activateEditor=()=>{


    }

    const itemRender=(props:ListViewItemProps)=>{
        let item=props.dataItem;
        return(
            <div>
                <div>{item.editby}&emsp;{item.edittime}</div>
                <div>{parse(item.note)}</div>
            </div>
        );
    }
    const {
        Bold,
        Italic,
        Underline,
    } = EditorTools;

    useEffect(() => {
        getAcctNotes()
    }, []);
    return(
        <Dialog title={"Account Notes"} onClose={props.onClose} width={500}>
            {showAdd && <Button onClick={hideAddButton} style={{marginBottom:20}}>Add Note</Button>}
            {showEditor &&
                <>
                <ButtonGroup style={{marginBottom:20}}>
                    <Button>Save</Button>
                    <Button onClick={showAddButton}>Cancel</Button>
                </ButtonGroup>      
                <Editor
                tools={[
                    [Bold, Italic, Underline]
                ]}
                contentStyle={{ height: 200 }}
                defaultContent={""}
                />
                </>
            }
            <ListView
                data={accountNotes}
                item={itemRender}            
            />
        </Dialog>
    )
}
